<template>
<div class="chapter">
<div class="inner_page">
<p class="tx">
<i>“The Russians are a people who historically have needed a belief system to live by,
					whether Communism or Russian Orthodoxy…they have been uncomfortable with our notion…that
					the individual himself is left to develop philosophy, faith, and the meaning of life.”</i>
</p>
<p class="txr">
<i>Hedrick Smith, <span class="underline" id="APM">The New Russians</span>, p. xxvi</i> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?253fc68c